import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface TrainingRequestModalData {
  employeeId: number;
  employeeName: string;
  defaultMessage: string;
}

@Component({
  selector: 'app-training-request-modal',
  templateUrl: './training-request-modal.component.html',
  styleUrls: ['./training-request-modal.component.css']
})
export class TrainingRequestModalComponent implements OnInit {
  message: string = '';
  defaultMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<TrainingRequestModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TrainingRequestModalData
  ) {
    this.defaultMessage = data.defaultMessage || `Assign next training course to ${data.employeeName}`;
    this.message = this.defaultMessage;
  }

  ngOnInit(): void {}

  send(): void {
    // Use the custom message if provided, otherwise use default
    const messageToSend = this.message.trim() || this.defaultMessage;
    this.dialogRef.close({ message: messageToSend });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
